export var defaultRenderLabel = function defaultRenderLabel(item) {
  return item.label;
};